
/** InsCoder 2026-02-12 B + Policy Tabs Max Height & Responsive Recalc **/
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.policy-tabs-section');
  sections.forEach(section => {
    const body = section.querySelector('.policy-tabs-body');
    const contents = Array.from(section.querySelectorAll('.policy-tab-content'));
    if (!body || contents.length === 0) return;

    const measure = (el) => {
      const prev = {
        display: el.style.display,
        position: el.style.position,
        visibility: el.style.visibility,
        left: el.style.left,
        top: el.style.top,
      };
      const wasActive = el.classList.contains('active');
      if (!wasActive) el.style.display = 'block';
      // el.style.position = 'absolute';
      // el.style.visibility = 'hidden';
      // el.style.left = '-9999px';
      // el.style.top = '0';
      const h = el.offsetHeight;
      el.style.display = prev.display;
      el.style.position = prev.position;
      el.style.visibility = prev.visibility;
      el.style.left = prev.left;
      el.style.top = prev.top;
      return h;
    };

    const computeMax = () => {
      let max = 0;
      contents.forEach(c => { max = Math.max(max, measure(c)); });
      body.style.minHeight = max + 'px';
    };

    computeMax();

    let rafId;
    const scheduleRecompute = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(computeMax);
    };

    window.addEventListener('resize', scheduleRecompute, { passive: true });
    section.querySelectorAll('.policy-tab-title').forEach(title => {
      title.addEventListener('click', ()=>{
        // scheduleRecompute();

        computeMax();
        title.scrollIntoView({
          behavior: 'smooth',
          block: "nearest",
          inline: 'center'
        });
        const targetId = title.getAttribute('data-tab-target');
        const container = title.closest('.policy-tabs-section');
        if (!targetId || !container) return;

        // Remove active class from all titles in this container
        const containerTitles = container.querySelectorAll('.policy-tab-title');
        if (containerTitles.length > 0) {
          containerTitles.forEach(t => t.classList.remove('active'));
        }
        // Add active class to clicked title
        title.classList.add('active');

        // Hide all contents
        const containerContents = container.querySelectorAll('.policy-tab-content');
        if (containerContents.length > 0) {
          containerContents.forEach(c => c.classList.remove('active'));
        }
        // Show target content
        const targetContent = container.querySelector('#' + targetId);
        if (targetContent) targetContent.classList.add('active');
      });
    });
  });
});
/** InsCoder 2026-02-12 E + Policy Tabs Max Height & Responsive Recalc **/
